export default {
  BASIC: 'basic',
  GOLD: 'gold',
};
